module.exports = __webpack_public_path__ + "static/media/light-b-5.fa80c7a0.png";